<template>
  <ContentWithHeader>
    <template #header>
      <button
        class="btn no-bg"
        @click="setPosSection('choose-product')">
        <i class="fas fa-times"/>
      </button>
    </template>
    <template #content>
      <div class="wrapper">
        <div class="col-12 mt-4 mb-1 status">
          {{ $t('message.discount') }}
        </div>
        <ul class="col-12 no-padding items">
          <li
            v-for="(item, index) in filterDiscounts"
            :key="index"
            class="row no-margin item"
            @click="onSelectItem(item)"
          >
            <div class="d-flex justify-content-between col">
              <span>
                {{ item.discount_name }}
              </span>
              <span>
                <span v-if="item.value_type == 'percentage'">{{ item.value_amount }}%</span>
                <span v-if="item.value_type == 'number'">{{ getNumber(item.value_amount) }} {{ currency }}</span>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </ContentWithHeader>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContentWithHeader from '../common/ContentWithHeader.vue'

export default {
  components: {
    ContentWithHeader,
  },

  computed: {
    ...mapGetters({
      discounts: 'getDiscounts',
      getPosOrdersById: 'getPosOrdersById',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
    }),
    filterDiscounts() {
      return this.discounts.filter((discount) => discount.type === 'general')
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'updatePosOrderDiscounts',
    ]),
    onSelectItem(discount) {
      this.selectedDiscount(discount)
      this.setPosSection('mobile-prepayment')
    },
    transformDiscounts (selectedDiscounts) {
      const results = []
      for (const discount of selectedDiscounts) {
        const dataSet = {
          discount_id: discount.discount_id,
          discount_name: discount.discount_name,
          type: discount.type,
        }
        dataSet['value_type'] = discount.value_type
        dataSet['value_amount'] = discount.value_amount
        results.push(dataSet)
      }
      return results
    },
    selectedDiscount (discount) {
      const orders = this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      for (const order of orders) {
        const transformedDiscounts = this.transformDiscounts([discount])
        const filterDiscounts = [
          ...order.discounts,
          ...transformedDiscounts,
          // get none duplicated
        ].reduce((acc, cur) => {
          const foundIndex = acc.findIndex((item) => item.discount_id === cur.discount_id)
          if (foundIndex === -1) {
            acc.push(cur)
          }
          return acc
        }, [])
        this.updatePosOrderDiscounts({
          orderId: order.uuid,
          discounts: filterDiscounts,
        })
      }
    },
  },
}
</script>

<style scoped>
.wrapper ul.items {
  overflow: auto;
}
.wrapper ul.items li.item {
  padding: 10px 15px;
  background: #fff;
  border-bottom: solid 1px #F2F2F2;
  cursor: pointer;
}
.wrapper ul.items li.item .col {
  padding: 0;
}
.wrapper ul.items li.item i.fa-circle {
  font-size: 8px;
  position: relative;
  top: -2px;
  margin-right: 12px;
  margin-left: 6px;
}
.wrapper ul.items li.item.available i.fa-circle {
  color: #8BC34A;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/DiscountList.vue